import { render, staticRenderFns } from "./__detail_item_list.vue?vue&type=template&id=48a0ede7&scoped=true&"
import script from "./__detail_item_list.vue?vue&type=script&lang=js&"
export * from "./__detail_item_list.vue?vue&type=script&lang=js&"
import style0 from "./__detail_item_list.vue?vue&type=style&index=0&id=48a0ede7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0ede7",
  null
  
)

export default component.exports